<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form ref="form" :model="query" label-width="80px" inline size="mini">
      <el-form-item label="联系电话">
        <el-input v-model="query.cellphone" clearable placeholder="请输入联系电话"></el-input>
      </el-form-item>
      <el-form-item label="运营类目">
        <el-select v-model="query.mode" clearable placeholder="请选择运营类目">
          <el-option label="棋牌" :value="1"></el-option>
          <el-option label="茶室" :value="2"></el-option>
          <el-option label="其他" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理状态">
        <el-select v-model="query.state" clearable placeholder="请选择处理状态">
          <el-option label="新录入" :value="0"></el-option>
          <el-option label="跟进中" :value="1"></el-option>
          <el-option label="已解决" :value="2"></el-option>
          <el-option label="未解决" :value="3"></el-option>
          <el-option label="已删除" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 数据展示区域 -->
      <el-table :data="ambitionList" style="width: 100%" height="650px" stripe border>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="city" label="意愿城市" width="160"></el-table-column>
        <el-table-column label="运营类目" width="80">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.mode === 1">棋牌</el-tag>
            <el-tag type="success" v-else-if="scope.row.mode === 2">茶室</el-tag>
            <el-tag type="info" v-else-if="scope.row.mode === 3">其他</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="联系姓名" width="160"></el-table-column>
        <el-table-column prop="cellphone" label="联系电话" width="160"></el-table-column>
        <el-table-column prop="message" label="留言建议"></el-table-column>
        <el-table-column prop="remark" label="处理备注" width="200"></el-table-column>
        <el-table-column label="处理状态" width="80">
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.state === 0">新录入</el-tag>
            <el-tag type="" v-else-if="scope.row.state === 1">跟进中</el-tag>
            <el-tag type="success" v-else-if="scope.row.state === 2">已解决</el-tag>
            <el-tag type="warning" v-else-if="scope.row.state === 3">未解决</el-tag>
            <el-tag type="info" v-else-if="scope.row.state === 4">已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="140"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="140"></el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="warning" size="small" @click="deal(scope.row.uuid)">处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="curPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 处理意见反馈对话框 -->
    <el-dialog title="处理加盟合作" :visible.sync="ambitionDialogVisible" @close="close('ambitionFormRef')" width="30%">
      <el-form ref="ambitionFormRef" :model="ambitionForm" :rules="ambitionRules" label-width="120px">
        <el-form-item label="处理结果" prop="state">
          <el-select v-model="ambitionForm.state" placeholder="请选择处理结果">
            <el-option label="跟进中" value="1"></el-option>
            <el-option label="已解决" value="2"></el-option>
            <el-option label="未解决" value="3"></el-option>
            <el-option label="已删除" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理备注" prop="remark">
          <el-input v-model="ambitionForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ambitionDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dealSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片未渲染 -->
  </div>
</template>

<script>
import { ambitionList, editAmbition } from '@/API/ambition'
export default {
  name: 'ambition',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        cellphone: '',
        state: ''
      },
      //   意见反馈数据
      ambitionList: [],
      //   数据总条数
      total: 0,
      // 处理意见反馈对话框
      ambitionDialogVisible: false,
      // 处理意见反馈表单数据
      ambitionForm: {
        uuid: '',
        state: '',
        remark: ''
      },
      ambitionRules: {
        state: [{ required: true, message: '请选择处理结果', trigger: 'blur' }],
        remark: [{ required: true, message: '请输入处理备注', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getAmbitionList()
  },
  methods: {
    // 获取意见反馈数据
    async getAmbitionList() {
      const { data: res } = await ambitionList(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.ambitionList = res.data.entities
      this.total = res.data.totalSize
    },
    // 搜索按钮点击触发
    seach() {
      this.query.curPage = 1
      this.getAmbitionList()
    },
    // 重置按钮点击触发
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.getAmbitionList()
    },
    // 处理意见反馈
    deal(uuid) {
      this.ambitionForm.uuid = uuid
      this.ambitionDialogVisible = true
    },
    // 处理意见反馈提交
    async dealSubmit() {
      this.$refs.ambitionFormRef.validate(async valid => {
        if (!valid) return
        const { data: res } = await editAmbition(this.ambitionForm)
        if (res.code === 200) {
          this.$message.success(res.message)
          this.$refs.ambitionFormRef.resetFields()
          this.ambitionDialogVisible = false
          this.getAmbitionList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getAmbitionList()
    },
    // 监听curPage
    curPageChange(newPage) {
      this.query.curPage = newPage
      this.getAmbitionList()
    },
    close(formRef) {
      this.$refs[formRef].resetFields()
    }
  }
}
</script>

<style lang="less" scoped>
.el-form {
  .el-input {
    width: 180px;
  }
  .el-select {
    width: 180px;
  }
  .custodyBtn {
    margin-left: 60px;
  }
}
.el-pagination {
  margin-top: 30px;
}
.el-card__body {
  padding: 0;
  .el-form-item {
    margin: 0;
    margin: 0;
    width: 33%;
  }
  .uuidBox {
    position: relative;
    cursor: pointer;
  }
  .el-pagination {
    padding-top: 20px;
  }
}
</style>
